export default "__VITE_ASSET__16482bcd__"